<template>
  <div class="loader">
    <div class="factCard loading">
      <div class="info">
        <div class="details">
          <Vue3Lottie
            :animationLink="`/assets/lottie/surveyTool/loader.json`"
            :loop="true"
            height="auto"
          />
          <h2 class="factTitle">
            Curating all the information you'll need to decide if we're a good
            fit
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Vue3Lottie } from "vue3-lottie";
import "vue3-lottie/dist/style.css";
</script>
